export default __webpack_public_path__ + "static/media/Letter A.2a98ae67.mov";